<template>
  <svg
    width="21"
    height="22"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0.5 0.25 20 21"
  >
    <path
      class="icon-fill"
      d="m10.5,19.35l-8.4,-5.1l-1.6,0.9l10,6.1l10,-6.1l-1.5,-0.9l-8.5,5.1z"
    />
    <path
      class="icon-fill"
      d="m18.5,5.25l-5.7,3.5l-1.8,1.1l-0.5,0.3l-0.4,-0.3l-1.9,-1.1l-5.7,-3.5l8,-5l8,5z"
    />
    <path
      class="icon-fill"
      d="m18.8,5.55l0,6.4l0,0l-1.6,1l-6.5,3.9l0,-6.5l1.2,-0.7l1.7,-1l5.2,-3.1z"
    />
    <path
      class="icon-fill"
      d="m10.3,10.35l0,6.5l-3.7,-2.3l0,-2.6l-1.5,-0.9l0,2.6l-1.2,-0.7l-1.7,-1l0,0l0,-6.4l0,0l5.2,3.1l1.7,1l1.2,0.7z"
    />
  </svg>
</template>

<script>
export default {
  name: 'OverlaysIcon',
};
</script>
<style scoped lang="scss">
svg {
  margin-top: 3px;
}
</style>
